import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngxs/store';
import { repeat } from 'rxjs/operators';
import { tags } from './../../../../../../../_shared/constants/customTags.const';
import { TreatmentReservationRequest } from './../../../../../../../_shared/model/treatment/treatmentReservationRequest';
import { Term } from './../../../../../../../_shared/state/treatment/treatment.actions';
@Component({
    selector: 'trt-wid-m-term-gen',
    templateUrl: './trt-wid-m-term-gen.component.html',
    styleUrls: ['./trt-wid-m-term-gen.component.scss'],
})
export class TrtWidMTermGenComponent implements OnInit {
    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix, @typescript-eslint/no-explicit-any
    public onCloseGenerator: EventEmitter<any> = new EventEmitter();

    public term: TreatmentReservationRequest;

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public reacurringType: any = tags.RECURRING_NEW.table.filter(el => el.id != 5 && el.id != 1 && el.id != 2 && el.id != 6);
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public termType: any = tags.TERM_TYPE;
    public generatorForm: FormGroup;
    public isDetailsOpend = false;
    constructor(
        private fb: FormBuilder,
        private store: Store,
    ) {}

    ngOnInit() {
        this.createForm();
    }

    //PUBLIC

    public generateNewTerms(): void {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const data = this.generatorForm.getRawValue();
        this.store.dispatch(new Term.GenerateNewTerms()).pipe(repeat(1)).subscribe();
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public equalsAnyByReacurring(o1: any, o2: any): boolean {
        if (!o1 || !o2) {
            return;
        }
        return o1 === o2;
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public equalsAnyById(o1: any, o2: any): boolean {
        if (!o1 || !o2) {
            return;
        }
        return o1.id === o2.id;
    }

    //PRIVATE

    private createForm(): void {
        this.generatorForm = this.fb.group({
            recurringType: new FormControl('', Validators.required),
            recurringFrequency: new FormControl('', Validators.required),
            termType: new FormControl(''),
            selectedSubcontractor: new FormControl('', Validators.required),
            selectedDate: new FormControl('', Validators.required),
            selectedDateView: new FormControl('', Validators.required),
            selectedTime: new FormControl('', Validators.required),
            selectedTimeEnd: new FormControl('', Validators.required),
            selectedService: new FormControl('', Validators.required),
            selectedAsset: new FormControl('', Validators.required),
            customTagId: new FormControl(),
        });
    }

    get formData() {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return <any>this.generatorForm.value;
    }

    get formControls() {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return <any>this.generatorForm.controls;
    }
}

// recurringType: this.fb.control({ value: tags?.RECURRING_NEW?.obj?.WEEKLY, disabled: false }),
// recurringFrequency: this.fb.control({ value: 1, disabled: false }),
// termType: this.fb.control({ value: tags.TERM_TYPE.obj.DRAFT, disabled: false }),
